import { useOptionalUserContext } from '../context/user-context'
import { mutation, query } from '../graphql'

export function useLifecycleStageTracking() {
  const isAdmin = useOptionalUserContext()?.isAdmin === true

  const trackLifecycleStage = async ({
    aivy_form_id,
    lifecycle_stage,
    lifecycle_stage_before,
    lead_progress,
    partner_id,
    updateOnlyPartnerId = false
  }) => {
    // Aivy-Admins sind keine Leads. Wechselt ein Admin per Gruppenwechsel in
    // einen Kunden, wäre aivy_form_id die des Kunden, und Admin-Klicks würden
    // dessen Lifecycle-Stage in HubSpot setzen (etwa ONBOARDING_COMPLETED).
    if (isAdmin) return
    if (!aivy_form_id) return

    try {
      // query() resolvet bereits das entpackte Operations-Ergebnis
      // (data[origin]) — KEIN formRes.data.getForm, das ist immer undefined
      // und hat frueher still das komplette data-Feld geklobbert.
      const currentForm = await query({
        query: 'getForm',
        variables: { id: aivy_form_id }
      })
      const currentFormLifecycle_stage = currentForm?.lifecycle_stage || ''

      if (
        lifecycle_stage === 'PLG_CREATED' &&
        currentFormLifecycle_stage !== ''
      )
        return

      if (updateOnlyPartnerId) {
        await mutation({
          mutation: 'updateForm',
          input: {
            id: aivy_form_id,
            partner_id,
            updatedAt: new Date().toISOString()
          }
        })
        return
      }

      // Bestehendes data robust lesen: kann Objekt (Map), einfach oder doppelt
      // JSON-stringifiziert sein (AWSJSON + Backend schreibt RECEIVED als String).
      // null = Lesen fehlgeschlagen obwohl data existiert → data NICHT anfassen.
      const raw = currentForm?.data
      let dataObj = null
      if (raw == null) {
        dataObj = {}
      } else if (typeof raw === 'object') {
        dataObj = raw
      } else if (typeof raw === 'string') {
        try {
          let parsed = JSON.parse(raw)
          if (typeof parsed === 'string') parsed = JSON.parse(parsed)
          if (parsed && typeof parsed === 'object') dataObj = parsed
        } catch (_) {
          dataObj = null
        }
      }

      // Onboarding-Fortschritt ins freeform data-Feld (onboarding_progress),
      // NICHT ins lead_progress — das gehoert dem Funnel (Skala 0–100, =100 bei
      // RECEIVED). last_activity bleibt unangetastet (Funnel-Step-Trail).
      // data nur mitschreiben, wenn der Merge sicher ist — sonst lieber den
      // Fortschritt dieses Calls verlieren als Lead-Daten zu ueberschreiben.
      const input = {
        id: aivy_form_id,
        lifecycle_stage,
        partner_id,
        updatedAt: new Date().toISOString()
      }
      if (dataObj !== null && lead_progress != null) {
        input.data = JSON.stringify({
          ...dataObj,
          onboarding_progress: lead_progress
        })
      }

      await mutation({ mutation: 'updateForm', input })
    } catch (e) {
      console.error('trackLifecycleStage failed', e)
    }
  }

  return { trackLifecycleStage }
}

export const LIFE_CYCLE_STAGES = {
  PLG_CREATED: 'PLG_CREATED',
  ONBOARDING_STARTED: 'ONBOARDING_STARTED',
  ONBOARDING_CAREER_CREATED: 'ONBOARDING_CAREER_CREATED',
  ONBOARDING_TALENT_CREATED: 'ONBOARDING_TALENT_CREATED',
  ONBOARDING_COMPLETED: 'ONBOARDING_COMPLETED',
  FIRST_CAREER_CREATED: 'FIRST_CAREER_CREATED',
  FIRST_TALENT_INVITED: 'FIRST_TALENT_INVITED',
  FIRST_ASSESSMENT_VIEWED: 'FIRST_ASSESSMENT_VIEWED',
  ACTIVE_USER: 'ACTIVE_USER',
  CHURNED: 'CHURNED'
}
